import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { request } from '@/api/service';
import utils from '@/utils';
export default {
  name: 'chart',
  props: {
    value: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data: function data() {
    return {
      rank: false,
      echartreset: false,
      select: '',
      //   total: "888",
      //   list: ["今日收益", "7天总收益", "近30天收益", "今年总收益"],
      //   active: false,
      activeName: '1',
      market_id: '',
      agent_id: '',
      start_time: '',
      label1: this.$t('Earnings in the last 7 days'),
      label2: this.$t('Earnings in the last 30 days'),
      label3: this.$t('Earnings this year'),
      days: 365,
      chartData: {
        columns: ['date', 'smscount'],
        rows: [//   { 日期: "1-1", 订单量: 8, 收益: 1213 },
          //   { 日期: "1-2", 订单量: 8, 收益: 1223 },
          //   { 日期: "1-3", 订单量: 8, 收益: 2123 },
          //   { 日期: "1-4", 订单量: 8, 收益: 4123 },
          //   { 日期: "1-5", 订单量: 8, 收益: 3123 },
          //   { 日期: "1-6", 订单量: 8, 收益: 7123 },
        ]
      },
      type: null,
      innerType: null,
      washList: []
    };
  },
  watch: {
    value: {
      handler: function handler(value) {
        this.echartreset = value;
      },
      immediate: true
    }
  },
  //   computed: {
  //     newList() {
  //       return this.list.map((item) => {
  //         this.$set(item, "isShow", false);
  //         return item;
  //       });
  //     },
  //   },
  //   {"market_id":1,"start_time":"2021-04-27","days":365}
  created: function created() {
    var _this = this;

    // 初始化洗衣店
    var aData = new Date();
    this.value = aData.getFullYear() + '-' + (aData.getMonth() + 1) + '-' + aData.getDate();
    this.start_time = this.value; // 2019-8-20

    var data = {
      // market_id: this.market_id,
      start_time: this.start_time,
      days: 7 // agent_id: this.agent_id

    }; //   console.log("传参", data);

    request({
      method: 'post',
      url: '/api/sms-record/data',
      data: data // headers: {},

    }).then(function (res) {
      var data = res.sy;
      _this.chartData.rows = data;
    }); //   初始化折线图
  },
  //   watch: {
  //     select: function(value) {
  //       console.log(value);
  //     },
  //   },
  methods: {
    //   选择洗衣店
    choose: function choose(value) {
      var _this2 = this;

      console.log('切换洗衣店', value);
      console.log(this.washList);
      var obj = this.washList.find(function (item) {
        return item.name === value;
      });
      this.market_id = Number(obj.value);
      var aData = new Date();
      this.value = aData.getFullYear() + '-' + (aData.getMonth() + 1) + '-' + aData.getDate();
      this.start_time = this.value; // 2019-8-20

      var data = {
        market_id: this.market_id,
        start_time: this.start_time,
        days: 7
      };
      console.log('传参', data);
      request({
        method: 'post',
        url: '/api/sms-record/data',
        data: data // headers: {},

      }).then(function (res) {
        console.log(res);
        var data = res.sy;
        console.log('图表数据', data);
        _this2.chartData.rows = data;
      });
    },
    // 切换tab栏
    handleClick: function handleClick(tab, event) {
      var _this3 = this;

      // 获取当前时间
      var aData = new Date();
      this.value = aData.getFullYear() + '-' + (aData.getMonth() + 1) + '-' + aData.getDate();
      this.start_time = this.value; // 2019-8-20

      var data = {
        // market_id: this.market_id,
        start_time: this.start_time,
        days: '' // agent_id: this.agent_id

      };

      if (tab.name == '1') {
        data.days = 7;
      }

      if (tab.name == '0') {
        data.days = 7;
      }

      if (tab.name == '2') {
        data.days = 30;
      }

      if (tab.name == '3') {
        data.days = 365;
      } //   请求数据


      request({
        method: 'post',
        url: '/api/sms-record/data',
        data: data // headers: {},

      }).then(function (res) {
        //   console.log(res.data);
        var data = res.sy;
        console.log(data);
        _this3.chartData.rows = data;
      }).catch(function (err) {
        console.log(err);
        alert('网络错误');
      });
    }
  }
};